// Product visual — รูปจริงถ้ามี imgs[] ไม่งั้น motif+kw+sku ตามโทนหมวด (จาก vizHTML)
import { CATS, MOTIF } from '../data/catalog.js';

export default function ProductViz({ product: p, size = 'mid', imgIndex = 0, tint = null, priority = false }) {
  const c = CATS[p.cat] || CATS['power-light'];
  if (p.imgs && p.imgs[imgIndex]) {
    return (
      <div className="viz" style={{ '--g1': tint || c.g1, '--g2': c.g2, '--tk': c.tk, '--mk': c.mk }}>
        {/* priority = hero/above-the-fold → โหลดทันที ไม่ lazy (กันบล็อกสีแวบ) */}
        <img src={p.imgs[imgIndex]} alt={p.name} loading={priority ? 'eager' : 'lazy'} fetchpriority={priority ? 'high' : undefined} decoding="async" />
      </div>
    );
  }
  const kwSize = size === 'big' ? '44px' : size === 'mid' ? '22px' : '11px';
  const subSize = size === 'big' ? '12px' : '9.5px';
  return (
    <div
      className="viz"
      style={{ '--g1': tint || c.g1, '--g2': c.g2, '--tk': c.tk, '--mk': c.mk }}
      dangerouslySetInnerHTML={{
        __html: `${MOTIF[c.motif]}<div class="lbl"><div class="kw" style="font-size:${kwSize}">${esc(p.kw)}</div><div class="sub" style="font-size:${subSize}">${esc(p.sku)}</div></div>`,
      }}
    />
  );
}

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
